// extracted by mini-css-extract-plugin
export default {"root":"report-header-bar-items_root__8B28R","placeHolderShimmer":"report-header-bar-items_placeHolderShimmer__KDheE"};